export const onLoadPrinter = payload => ({
    type: 'ON_LOAD_PRINTER',
    payload,
})

export const onChange = payload => ({
    type: 'ON_CHANGE_PRINTER',
    payload,
})

export const onSavePrinter = payload => ({
    type: 'ON_SAVE_PRINTER',
    payload,
})
export const onOk = () => ({
    type: 'ON_OK_PRINTER',
})



// WEBPACK FOOTER //
// ./src/actions/settingPrinterAction.js